let test = {
  require: 'http://test-yj-01.dongguajie.cn/api',
  goPath: 'http://test-yj-01.dongguajie.cn/yj_project/#/',
  // goPath: "http://csh5.dongguajie.cn/#/",
  // http://test_yj.dongguajie.cn/wap/login/index?merchant_id=1,
  masterPay: 'http://test-yj.dongguajie.cn/yj_project/#',
  payUrl: 'http://test-yj.dongguajie.cn/api',
  linkUrl: 'http',
  liveUrl: 'https://tlive-service.7dingdong.com/api',
  liveAppKey: '46C0ABF8910F4F390785747631008EE9'
}

//本地正式测试访问20210828
let release = {
  require: 'https://jnlx.yijiudingdong.com/api',
  goPath: 'https://jnlx.yijiudingdong.com/yj_project/#/',
  masterPay: 'https://api.yijiudingdong.com/yj_project/#', //正式跳转支付
  payUrl: 'https://api.yijiudingdong.com/api', //支付调起
  linkUrl: 'https',
  liveUrl: 'https://live-service.7dingdong.com/api',
  liveAppKey: '8CC60A23D933D3BAC59092EDBFCEB807'
}

let testRelease = {
  require: window.location.href.split('.cn')[0] + '.cn/api', //接口路径
  // require: 'http://yj01.yijiudingdong.com/api',
  goPath: localStorage.getItem('httpsConfig') + './yj_project/#/', //跳转路径
  masterPay: 'https://api.yijiudingdong.com/yj_project/#', //正式跳转支付
  // masterPay: 'https://merchant-api.yijiudingdong.com/yj_project/#', //测试跳转支付
  masterPay: 'http://test-yj.dongguajie.cn/yj_project/#',
  payUrl: 'http://test-yj.dongguajie.cn/api',
  linkUrl: 'http',
  liveUrl: 'https://tlive-service.7dingdong.com/api',
  liveAppKey: '46C0ABF8910F4F390785747631008EE9'
}

let master = {
  require: window.location.href.split('.com')[0] + '.com/api', //接口路径
  // require: 'http://yj01.yijiudingdong.com/api',
  goPath: localStorage.getItem('httpsConfig') + './yj_project/#/', //跳转路径
  masterPay: 'https://api.yijiudingdong.com/yj_project/#', //正式跳转支付
  // masterPay: 'https://merchant-api.yijiudingdong.com/yj_project/#', //测试跳转支付
  payUrl: 'https://api.yijiudingdong.com/api', //支付调起
  linkUrl: 'https',
  liveUrl: 'https://live-service.7dingdong.com/api',
  liveAppKey: '8CC60A23D933D3BAC59092EDBFCEB807'
}
export default master
